import {
    ApiBaseService,
    type EnhancedFetch,
    type EnhancedFetchOptions,
    type PaginatedFetch,
    type PaginatedFetchOptions,
} from "./ApiBaseService";
import type { Task } from "~/models/Automation";
import { faEye } from "@fortawesome/pro-duotone-svg-icons";
import {
    faArrowsRetweet,
    faArrowsSpin,
    faCommand,
} from "@fortawesome/pro-regular-svg-icons";
import { faBolt } from "@fortawesome/pro-solid-svg-icons";
import type { ApiResponse } from "~/types/ApiResponse";
import type { FetchOptions } from "ofetch";

export default class TaskService extends ApiBaseService {
    public list(
        options?: Partial<PaginatedFetchOptions>,
    ): PaginatedFetch<Task[]> {
        return this.paginate<Task[]>(
            this.route("api.tasks.index", "/tasks"),
            options as PaginatedFetchOptions,
        );
    }

    public find(
        id: string,
        options?: EnhancedFetchOptions,
    ): EnhancedFetch<Task> {
        return this.enhancedFetch<Task>(
            this.route("api.tasks.show", "/tasks/{event}", {
                event: id,
            }),
            options,
        );
    }

    public findRequest(
        id: string,
        options?: FetchOptions,
    ): Promise<ApiResponse<Task>> {
        return this.request<ApiResponse<Task>>(
            this.route("api.tasks.show", "/tasks/{event}", {
                event: id,
            }),
            options,
        );
    }

    public dropdown(task: any) {
        const items = [
            {
                label: "View",
                icon: faEye,
                to: {
                    name: "tasks-id",
                    params: { id: task.id },
                },
            },
        ];

        const related = [];

        if (task.automation?.uuid) {
            related.push({
                label: "View Automation",
                icon: faArrowsRetweet,
                to: {
                    name: "automations-id",
                    params: { id: task.automation.uuid },
                },
            });
        }

        if (task.event?.id) {
            related.push({
                label: "View Event",
                icon: faBolt,
                to: {
                    name: "settings-events-id",
                    params: { id: task.event.id },
                },
            });

            if (
                task.event.custom_app?.uuid ||
                task.event.trigger_connection?.uuid
            ) {
                related.push({
                    label: "View App",
                    icon: faCommand,
                    to: {
                        name: "apps-id",
                        params: {
                            id:
                                task.event.custom_app?.uuid ??
                                task.event.trigger_connection?.uuid,
                        },
                    },
                });
            }
        }

        if (task.process?.id) {
            related.push({
                label: "View Run",
                icon: faArrowsSpin,
                to: {
                    name: "settings-runs-id",
                    params: { id: task.process?.id },
                },
            });
        }

        if (useRoute().name === items[0].to.name) {
            items.splice(0, 1);
        }

        const groups = [];

        if (items.length) {
            groups.push(items);
        }

        if (related.length) {
            if (items.length) items[0].label += ` Task`;
            groups.push([{ label: "Related", disabled: true }, ...related]);
        }

        return groups;
    }
}
